/**
 * Планирует callback на следующий кадр (requestAnimationFrame) или на следующий macrotask (setTimeout 0).
 * Удобно уступать главный поток там, где нет rAF (SSR, тесты).
 *
 * @param {function(): void} callback
 * @return {void}
 */
export default function scheduleNextPaint(callback) {
  if (typeof globalThis.requestAnimationFrame === 'function') {
    globalThis.requestAnimationFrame(callback);
  } else {
    setTimeout(callback, 0);
  }
}
